<!-- Agregar convenios a ProductoFromaDesembolso -->


<!-- Lado Derecho -->
<div class="grid">

  <!-- Lista Convenios -->
  <div class="col-12 md:col-5">
    <div class="card card-w-title">
      <div class="grid">
        <div class="col-12">
          <label>{{ 'FORMADESEMBOLSO.LBL_CONVENIOSHABILITADOS' | translate}}</label>
        </div>
        <div class="col-12">
          <p-listbox [options]="conveniosSinProductoFd" [(ngModel)]="convenioSelect" filter="filter"
                     [listStyle]="{'height':'250px'}" optionLabel="nombre" class="p-picklist-pl-unset"
                     emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                     emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}">
          </p-listbox>
        </div>
      </div>
    </div>
  </div>

  <!-- Botones -->
  <div class="col-12 md:col-2 text-center" style="margin-top: 100px;">
    <button type="button" class="p-button btn" icon="fa fa-chevron-circle-right" data-toggle="tooltip"
            title="{{'BTN_TRASLADAR' | translate}}"
            pButton (click)="asignarConvenioToProductoFd(convenioSelect)"></button>
    <br><br>
    <button type="button" class="p-button btn" icon="fa fa-angle-double-right" data-toggle="tooltip"
            title="{{'BTN_TRASLADAR' | translate}}"
            pButton (click)="asignarConvenioToProductoFd(null)"></button>
    <br><br>
    <button type="button" class="p-button btn" icon="fa fa-chevron-circle-left" data-toggle="tooltip"
            title="{{'BTN_TRASLADAR' | translate}}"
            pButton (click)="desAsignarConvenioToProductoFd(prodConvFdSelect)"></button>
    <br><br>
    <button type="button" class="p-button btn" icon="fa fa-angle-double-left" data-toggle="tooltip"
            title="{{'BTN_TRASLADAR' | translate}}"
            pButton (click)="desAsignarConvenioToProductoFd(null)"></button>
  </div>

  <!-- Lista ProductosFd -->
  <div class="col-12 md:col-5">
    <div class="card card-w-title">
      <div class="grid">
        <div class="col-12">
          <label>{{ 'FORMADESEMBOLSO.LBL_CONVENIOSHABILITADOSPRODUCTO' | translate}}</label>
        </div>
        <div class="col-12">
          <p-listbox [options]="prodConvFdsConConvenio " [(ngModel)]="prodConvFdSelect"
                     [listStyle]="{'height':'250px'}" filter="filter" optionLabel="nombreConvenio" class="p-picklist-pl-unset"
                     emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                     emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}">
          </p-listbox>
        </div>
      </div>
    </div>
  </div>

  <!-- Regresar -->
  <div class="col-12 text-center">
    <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button" pButton (click)="regresar()"></button>
  </div>


</div>
